export const POSITIONS_MAP = {
  inline: "inline",
  default: "",
} as const;
